<template>
  <v-card class="mx-auto" max-width="500" tile flat>
    <v-list-item-group v-model="selected" active-class="gray--text">
      <v-list-item v-for="item in list" :key="item.routeName" two-line>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>

    <v-card-actions class="px-0">
      <v-btn
        outlined
        depressed
        large
        color="grey"
        @click.prevent="$emit('close')"
      >
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="selected === undefined"
        depressed
        color="success"
        large
        @click.prevent="push()"
      >
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ServiceTypesListPopup',

  data: () => ({
    selected: 0
  }),

  computed: {
    list() {
      return [
        {
          name: this.$t('SERVICES.SERVICE_NAME'),
          description: this.$t('SERVICES.SERVICE_DESCRIPTION'),
          routeName: 'customer-service.create'
        },
        {
          name: this.$t('SERVICES.INTERNAL_SERVICE_NAME'),
          description: this.$t('SERVICES.INTERNAL_SERVICE_DESCRIPTION'),
          routeName: 'internal-service.create'
        }
      ];
    }
  },

  created() {
    this.selected = 0;
  },

  methods: {
    push() {
      const { routeName } = this.list[this.selected];
      this.$router.push({ name: routeName });
    }
  }
};
</script>
